import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../../services/api";

const AccessFile = () => {
  const signature = localStorage.getItem("signature");
  const location = useLocation();
  const [message, setMessage] = useState("Processing your download...");

  const getQueryParam = (param: string) => {
    return new URLSearchParams(location.search).get(param);
  };

  useEffect(() => {
    const file_id = getQueryParam("file_id");
    const path = getQueryParam("path");

    const downloadFile = async () => {
      if (!signature || !file_id || !path) {
        setMessage("Missing required information to access file.");
        return;
      }

      try {
        const response = await api.post(
          "driveService/checkFileAccess",
          {
            file_id,
            path,
            signature,
          },
          {
            responseType: "blob",
          }
        );

        const contentType = response.headers["content-type"] || "application/octet-stream";
        const filename = path.split("/").pop() || "download";

        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        setMessage("✅ File downloaded successfully.");
      } catch (err: any) {
        console.error("Download error:", err);
        setMessage("❌ Something went wrong while downloading the file.");
      }
    };

    downloadFile();
  }, [location.search]);

  return (
    <div className="container mt-5 text-center">
      <p className="text-lg font-medium">{message}</p>
    </div>
  );
};

export default AccessFile;
